/**
 * UI Mode Configuration
 * Controls which panels are visible in public (preview) vs internal mode.
 * Panel IDs must match the TabsTrigger `value` props in EnterpriseDashboard.
 */

export const UI_MODES = {
  public: {
    label: 'Preview Mode',
    panels: [
      'metrics',           // System Metrics dashboard
      'chat',              // Chat UI
      'governance',        // Governance Security
      'trust',             // Audit Trail (TrustChain)
      'trustmap',          // Verification Map
      'tethers',           // Persona Tethers
      'osint',             // OSINT Threat Detection
      'demo',              // Demo Control
      'evidence',          // Live Proof -- validated user test cases
      'claw-ecosystem',    // Claw Ecosystem Governance
    ]
  },
  internal: {
    label: 'Internal Mode',
    panels: [
      // Everything public has
      'metrics', 'chat', 'governance', 'trust', 'trustmap',
      'tethers', 'osint', 'demo', 'evidence', 'claw-ecosystem',
      // Internal-only panels
      'modules',           // Module Console (CapsuleConsole)
      'dev-kit',           // Dev Kit (CapsuleDevKitPanel)
      'knowledge-pulse',   // Knowledge Pulse
      'briefing',          // Briefing Decks
      'sales',             // Sales Briefing
      'patents',           // Patent Protection
      'personas',          // Security Access (PersonaPanel)
    ]
  }
} as const;

export type UIMode = 'public' | 'internal';

export function isPanelVisible(panelId: string, mode: UIMode): boolean {
  return UI_MODES[mode].panels.includes(panelId as any);
}

export function getModeLabel(mode: UIMode): string {
  return UI_MODES[mode].label;
}

export function getVisiblePanels(mode: UIMode): readonly string[] {
  return UI_MODES[mode].panels;
}
